var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.5L48.15 68.1437C48.7 68.55 49.35 68.75 50 68.75C50.65 68.75 51.3 68.55 51.85 68.1437L100 37.5L51.875 0.624994C50.7625 -0.206256 49.2375 -0.206256 48.125 0.624994L0 37.5Z",
    fill: "#CAF7F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 0H18.75C15.3063 0 12.5 2.80625 12.5 6.25V75C12.5 76.725 13.9 78.125 15.625 78.125H84.375C86.1 78.125 87.5 76.725 87.5 75V6.25C87.5 2.80625 84.7 0 81.25 0Z",
    fill: "#F19236"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 18.75H71.875C73.6 18.75 75 17.35 75 15.625C75 13.9 73.6 12.5 71.875 12.5H28.125C26.4 12.5 25 13.9 25 15.625C25 17.35 26.4 18.75 28.125 18.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.875 25H28.125C26.4 25 25 26.4 25 28.125C25 29.85 26.4 31.25 28.125 31.25H71.875C73.6 31.25 75 29.85 75 28.125C75 26.4 73.6 25 71.875 25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.125 37.5H28.125C26.4 37.5 25 38.9 25 40.625C25 42.35 26.4 43.75 28.125 43.75H53.125C54.85 43.75 56.25 42.35 56.25 40.625C56.25 38.9 54.85 37.5 53.125 37.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.85 68.1437C51.3 68.55 50.65 68.75 50 68.75C49.35 68.75 48.7 68.55 48.15 68.1437L0 37.5V93.75C0 97.2 2.8 100 6.25 100H93.75C97.2 100 100 97.2 100 93.75V37.5L51.85 68.1437Z",
    fill: "#008F7F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.75 100H6.25C2.74375 100 0 97.2562 0 93.75C0 92.7562 0.475 91.8188 1.275 91.2313L48.15 59.9813C48.7 59.575 49.35 59.375 50 59.375C50.65 59.375 51.3 59.575 51.85 59.9813L98.725 91.2313C99.525 91.8188 100 92.7562 100 93.75C100 97.2562 97.2562 100 93.75 100Z",
    fill: "#19B1A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtEmail);
export default __webpack_public_path__ + "static/media/art_email.5b35b56d.svg";
export { ForwardRef as ReactComponent };